module.exports = __webpack_public_path__ + "img/rang3.210fa713.png";